<template>
  <div class="homepage">
    <section class="hero" aria-label="Selected work">
      <div class="mason">
        <div
          v-for="tile in page.collage"
          :key="tile.slug"
          class="t"
          :class="{ 'is-lineage': tile.slug === 'lineage' }"
        >
          <img
            v-if="tile.kind === 'image'"
            :src="tile.src"
            :alt="tile.alt"
            loading="eager"
          >
          <div
            v-else
            class="ph"
          >
            <span class="ph-k">{{ tile.kicker }}</span>
            <span class="ph-t">{{ tile.title }}</span>
            <span class="ph-b">{{ tile.broadcaster }}</span>
          </div>
        </div>
      </div>
      <div class="overlay">
        <small>{{ page.hero.kicker }}</small>
        <h1>Zara<br>Mills</h1>
        <p>{{ page.hero.role }} <b>/</b> {{ page.hero.medium }}</p>
      </div>
    </section>

    <div class="wrap">
      <h2>Credits</h2>
      <div class="tl">
        <div
          v-for="credit in page.credits"
          :key="credit.slug"
          class="it"
        >
          <span class="y">{{ credit.year }}</span>
          <img
            v-if="credit.image"
            :src="credit.image.src"
            alt=""
            loading="lazy"
          >
          <div
            v-else
            class="mini"
            aria-hidden="true"
          />
          <div>
            <h3>{{ credit.title }}</h3>
            <p><span class="role">{{ credit.role }} · {{ credit.broadcaster }}</span><span class="sep"> · </span><span class="dates">{{ credit.dates }}</span></p>
          </div>
        </div>
      </div>

      <div class="two">
        <div>
          <h2>Skills</h2>
          <ul>
            <li
              v-for="skill in page.skills"
              :key="skill"
            >
              {{ skill }}
            </li>
          </ul>
        </div>
        <div class="edu">
          <h2>Education</h2>
          <b>{{ page.education.qualification }}</b>
          <span>{{ page.education.institution }}<br>{{ page.education.years }}</span>
        </div>
      </div>

      <section class="prof">
        <h2>Profile</h2>
        <p class="summary">
          {{ page.profile }}
        </p>
      </section>
    </div>
  </div>
</template>

<script setup lang="ts">
import '@fontsource/anton/latin-400.css'
import '@fontsource/inter/latin-400.css'
import '@fontsource/inter/latin-700.css'
import { buildHomepage } from '~/data/homepage'

const page = buildHomepage()
</script>

<style src="../assets/css/homepage.css"></style>
